import styled from 'styled-components'

export const Title = styled.h1`
  font-family: Mulish;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 20px;
  color: var(--text-tertiary);
  margin-top: 1em;
`

export const Description = styled.h3`
  font-family: Mulish;
  font-style: normal;
  font-weight: normal;
  font-size: 1.7em;
  line-height: 15px;
  color: #858585;
`

export const ContainerTitleSecond = styled.div`
  display: flex;
  align-items: center;
  height: 6em;
  justify-content: space-between;

  > h1 {
    margin: 0;
    padding-top: 3em;
  }

  > button {
    margin-top: 4em;
  }
`

export const BoxBrand = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${({ isButton }) =>
    isButton ? 'transparent' : 'var(--background)'};
  border: ${({ isButton }) =>
    isButton ? '0px' : '1px solid var(--border-color-table)'};
  box-sizing: border-box;
  border-radius: 13px;
  padding: 24px;
  cursor: ${({ isButton }) => (isButton ? 'pointer' : 'normal')};
  max-width: 189px;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  h3,
  h4 {
    margin-top: 14px;
    margin-bottom: 0;
    text-align: center;
    font-size: var(--font-size-sm);
    color: var(--text-tertiary);
    font-weight: bold;
  }

  h4 {
    font-weight: normal;
  }
`

export const FileButton = styled.input`
  display: none;
`

export const ContainerUploadFiles = styled.section`
  &.fitContainer {
    display: flex;
    main {
      justify-content: center;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  h1 {
    color: var(--text-tertiary);
    font-size: var(--font-size-md);
    font-weight: 800;
  }

  h3 {
    color: var(--text-tertiary);
    font-size: var(--font-size-sm);
    font-weight: 400;
    margin: 32px 0 28px 0;
  }

  span.underline {
    text-decoration: underline;
  }
`

export const SubBoxContainerUploadFiles = styled.div`
  display: flex;
`

export const ImgLogo = styled.img`
  width: 17.5em;
  cursor: pointer;
`

export const ButtonsControl = styled.div`
  display: flex;
  margin-top: 1em;
  button {
    margin: 0 0.5em;
    font-size: 13px;
    &:hover {
      background-color: var(--theme-primary);
      color: var(--button);
    }
  }
`
